import { createContext, useContext, useState } from "react";

// Cria o contexto
const BranchContext = createContext();

// Provedor do contexto
export const BranchProvider = ({ children }) => {

    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branches, setBranches] = useState(null);
  
    return (
      <BranchContext.Provider value={{ selectedBranch, setSelectedBranch, branches, setBranches }}>
        {children}
      </BranchContext.Provider>
    );
  };
  
  // Hook para facilitar o acesso ao contexto
  export const useBranch = () => useContext(BranchContext);